import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Breadcrumbs, Typography } from '@material-ui/core';
import { withTheme } from '@material-ui/styles';
import moment from 'moment';

const stepMapping = {
    bookingpayouts: 'Booking payouts',
    clientpriceitems: 'Client price items',
    emaillogs: 'Email logs',
    priceitems: 'Price items',
    salesreports: 'Sales reports',
    systemfees: 'System fees',
    terminallocations: 'Terminal locations',
    usergroups: 'User groups',
    vendorpriceitems: 'Vendor price items',
    discountpackages: 'Discount packages',
    clientactivities: 'Activities',
    priceitemnames: 'Price item names',
    customreports: 'Custom reports'
};

const asList = ['activities', 'chains', 'client', 'tags'];

function locationToTrail(pathname) {
    const rawList = pathname.split('/').filter(s => s !== '');

    return rawList.reduce((result, step, i) => {
        if (step === 'update') {
            return result;
        }

        const decoded = decodeURIComponent(step);
        const parsedDate = moment(decoded, 'YYYY-MM-DD HH:mm:ss', true);

        let label = step.charAt(0).toUpperCase() + step.substring(1);
        if (parsedDate.isValid()) {
            label = parsedDate.format('ddd MMM DD, YYYY [at] hh:mm A');
        } else if (!isNaN(parseInt(step, 10)) || rawList[i - 1] === 'terminallocations') {
            label = `#${step}`;
        }
        if (Object.keys(stepMapping).includes(step)) {
            label = stepMapping[step];
        }

        let path = rawList.slice(0, i + 1);

        if (asList.includes(path[path.length - 1])) {
            path.push('list');
        }

        result.push({
            label,
            path: step === 'activity' ? '/admin/activities/list' : `/${path.join('/')}`
        });
        return result;
    }, []);
}

function BreadcrumbTrail({ theme }) {
    const { pathname } = useLocation();
    const [steps, setSteps] = useState(() => locationToTrail(pathname));

    useEffect(() => {
        setSteps(locationToTrail(location.pathname));
    }, [pathname]);

    if (steps.length > 0 && steps[0].label !== 'Admin') {
        return null;
    }
    if (steps.length === 0) {
        return null;
    }

    return (
        <Breadcrumbs aria-label="breadcrumb" style={{ marginTop: '10px', marginLeft: '10px' }}>
            {steps.map((step, index) => (
                <Typography key={index}>
                    <Link
                        to={step.path === '/admin' ? '#' : step.path}
                        style={{ color: theme.palette.primary.light }}
                    >
                        {step.label === 'Activity' ? 'Activities' : step.label}
                    </Link>
                </Typography>
            ))}
        </Breadcrumbs>
    );
}
export default withTheme(BreadcrumbTrail);
